(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7185],{

/***/ 53223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58337);
/* harmony import */ var _CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function CMSCard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: (_CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1___default().card),
    children: children
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (CMSCard);

/***/ }),

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomMetaHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CustomMetaHead(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [meta.title, " | ", "SUPERMARKET Κρητικός"]
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: meta.keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "index, follow"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:title",
      content: "".concat(meta.title, " | ").concat("SUPERMARKET Κρητικός")
    }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:url",
      content: meta.url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image",
      content: meta.image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:width",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:height",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:alt",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:site_name",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "canonical",
      content: meta.url
    })]
  });
}

/***/ }),

/***/ 66779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormattedImage; }
/* harmony export */ });
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12405);
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function FormattedImage(_ref) {
  var path = _ref.path,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      loading = _ref.loading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2, "&format=webp"),
      type: "image/webp"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2),
      type: "image/jpeg"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
      width: width,
      height: height,
      srcSet: "".concat(path),
      className: (_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default().img),
      alt: alt,
      loading: loading
    })]
  });
}

/***/ }),

/***/ 29962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CUSTOM_STYLES_V2 = {
  overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].overlay */ .Z.overlay),
  content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].content */ .Z.content), {}, {
    outline: '0'
  })
};

function GenericModalV2(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Συνέχεια' : _ref$submitText;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
    isOpen: _isModalOpen,
    style: CUSTOM_STYLES_V2,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContent),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
        children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
          children: mainText
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("footer", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .PrimaryButton */ .KM, {
          onClick: _onClickContinue,
          children: [" ", submitText]
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (GenericModalV2);

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 55686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _CMSCard_CMSCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53223);
/* harmony import */ var _GenericModalV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29962);
/* harmony import */ var _Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97844);
/* harmony import */ var _Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








function Newsletter(_ref) {
  var clubCard = _ref.clubCard;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var sideBarText = clubCard ? 'Θέλεις να μην χάνεις ευκαιρία να κερζίζεις; Γράψου στο Newsletter μας!' : "\u0398\u03AD\u03BB\u03B5\u03B9\u03C2 \u03BD\u03B1 \u03BC\u03B1\u03B8\u03B1\u03AF\u03BD\u03B5\u03B9\u03C2 \u03C4\u03B1 \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03BD\u03AD\u03B1 \u03C4\u03B7\u03C2 ".concat("ΚΡΗΤΙΚΟΣ", ";");
  var success = "\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF Newsletter \u03C4\u03C9\u03BD Supermarket ".concat("ΚΡΗΤΙΚΟΣ");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_CMSCard_CMSCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h5", {
        className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: sideBarText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("form", {
        className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().group),
        action: "//www.contactpigeon.com/apps/en/stem/subscribe.html/",
        method: "post",
        name: "form_sf_8874",
        onSubmit: function onSubmit() {
          return setOpenModal(true);
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          type: "hidden",
          value: "8874",
          name: "gm_pid"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("label", {
          htmlFor: "sfemail"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().input),
          type: "email",
          placeholder: "\u03A4\u03BF email \u03C3\u03BF\u03C5",
          id: "sfemail",
          name: "sfemail",
          required: true
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          type: "submit",
          name: "regme",
          className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
          value: "\u0395\u0393\u0393\u03A1\u0391\u03A6\u0397"
        })]
      })]
    }), openModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_GenericModalV2__WEBPACK_IMPORTED_MODULE_2__["default"], {
      mainText: success,
      isOpen: openModal,
      modalLabel: "Info modal"
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Newsletter);

/***/ }),

/***/ 51116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NextArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80075);
/* harmony import */ var _NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function NextArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), _classNames)),
    onClick: onClick,
    "aria-label": "next",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowRight */ .Bqb, {
      className: (_NextArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow forward - Arrow right"
    })
  });
}

/***/ }),

/***/ 55416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrevArrow; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19392);
/* harmony import */ var _PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function PrevArrow(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      carousel = _ref.carousel,
      smallArrow = _ref.smallArrow,
      leaflet = _ref.leaflet,
      category = _ref.category;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_classNames = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryContainer), category), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), !carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carouselContainer), carousel), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().smallArrow), smallArrow), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_classNames, (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().leaflet), leaflet), _classNames)),
    onClick: onClick,
    "aria-label": "previous",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineKeyboardArrowLeft */ .RL9, {
      className: (_PrevArrow_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
      alt: "Arrow back - Arrow left"
    })
  });
}

/***/ }),

/***/ 98924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JD": function() { return /* binding */ USER_PROFILE; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export ORDER_HISTORY */
var HOMEPAGE = '/';
var USER_PROFILE = '/user';
var ORDER_HISTORY = '/useσr/history';
var OFFERS = '/offers';
var CATEGORIES = '/categories';

/***/ }),

/***/ 32562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Leaflet; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 12 modules
var es = __webpack_require__(1515);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/components/CMSCard/CMSCard.jsx
var CMSCard = __webpack_require__(53223);
// EXTERNAL MODULE: ./src/components/Page Title/PageTitle.jsx
var PageTitle = __webpack_require__(36593);
// EXTERNAL MODULE: ./src/components/Sidebar/Newsletter.jsx
var Newsletter = __webpack_require__(55686);
// EXTERNAL MODULE: ./src/components/swiper-buttons/NextArrow.jsx
var NextArrow = __webpack_require__(51116);
// EXTERNAL MODULE: ./src/components/swiper-buttons/PrevArrow.jsx
var PrevArrow = __webpack_require__(55416);
// EXTERNAL MODULE: ./src/components/Leaflets/LeafletLayout.module.scss
var LeafletLayout_module = __webpack_require__(20516);
var LeafletLayout_module_default = /*#__PURE__*/__webpack_require__.n(LeafletLayout_module);
// EXTERNAL MODULE: ./src/components/FormattedImage/FormattedImage.jsx
var FormattedImage = __webpack_require__(66779);
// EXTERNAL MODULE: ./src/components/Leaflets/LeafletSlide.module.scss
var LeafletSlide_module = __webpack_require__(15342);
var LeafletSlide_module_default = /*#__PURE__*/__webpack_require__.n(LeafletSlide_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Leaflets/LeafletSlide.jsx




function LeafletSlide(_ref) {
  var _index = _ref._index,
      slide = _ref.slide,
      leafletUrl = _ref.leafletUrl,
      slug = _ref.slug;
  var loading = _index === 0 ? 'eager' : 'lazy';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "link",
    tabIndex: "-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: leafletUrl[_index] || "/".concat(slug),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LeafletSlide_module_default()).container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedImage/* default */.Z, {
            path: slide.path,
            alt: slide.text || 'προσφορά',
            width: 714,
            height: 1100,
            loading: loading
          })
        })
      })
    })
  }, _index);
}
;// CONCATENATED MODULE: ./src/components/Leaflets/LeafletLayout.jsx














function LeafletLayout(_ref) {
  var _leafletData$fields$s;

  var leaflet = _ref.leaflet,
      fulladiaLinks = _ref.fulladiaLinks,
      slug = _ref.slug;
  if (!leaflet || !leaflet[0]) return null;

  var _leaflet = (0,slicedToArray/* default */.Z)(leaflet, 1),
      leafletData = _leaflet[0];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (LeafletLayout_module_default()).page,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
      title: leafletData.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (LeafletLayout_module_default()).leafletContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LeafletLayout_module_default()).leaflet,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (LeafletLayout_module_default()).leafletTitle,
          children: leafletData.title
        }), leafletData.fields.sections[0].pdf && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
            infinite: true,
            className: (LeafletLayout_module_default()).slider,
            nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow/* default */.Z, {
              leaflet: true
            }),
            prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow/* default */.Z, {
              leaflet: true
            }),
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 500,
            children: (_leafletData$fields$s = leafletData.fields.sections[0].cover_image) === null || _leafletData$fields$s === void 0 ? void 0 : _leafletData$fields$s.map(function (slide, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(LeafletSlide, {
                slide: slide,
                _index: index,
                leafletUrl: leafletData.fields.sections[0]['leaflet-url'],
                slug: slug
              }, slide.id);
            })
          }, leafletData.fields.sections[0].pdf.id), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LeafletLayout_module_default()).textContent,
            dangerouslySetInnerHTML: {
              __html: leafletData.fields.sections[0].content
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (LeafletLayout_module_default()).linkButtonContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: routes/* OFFERS */.jn,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (LeafletLayout_module_default()).offersLink,
                children: "\u039E\u03B5\u03BA\u03AF\u03BD\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2 \u03C3\u03BF\u03C5!"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (LeafletLayout_module_default()).pdfLink,
              target: "_blank",
              rel: "noreferrer",
              href: leafletData.fields.sections[0].pdf.path,
              children: "\u039A\u03B1\u03C4\u03AD\u03B2\u03B1\u03C3\u03B5 \u03C4\u03BF pdf!"
            })]
          })]
        }), leafletData.fields.sections[0]['leaflet-url'] && !leafletData.fields.sections[0].pdf && leafletData.fields.sections.map(function (s) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (LeafletLayout_module_default()).videoContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (LeafletLayout_module_default()).textContent,
              dangerouslySetInnerHTML: {
                __html: s.content
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
              className: (LeafletLayout_module_default()).video,
              title: "video",
              src: s['leaflet-url']
            })]
          }, s['leaflet-url']);
        }), leafletData.fields.sections[0].cover_image && !leafletData.fields.sections[0].pdf && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LeafletLayout_module_default()).imgContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (LeafletLayout_module_default()).img,
            src: leafletData.fields.sections[0].cover_image.path,
            alt: "\u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03BC\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LeafletLayout_module_default()).textContent,
            dangerouslySetInnerHTML: {
              __html: leafletData.fields.sections[0].content
            }
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LeafletLayout_module_default()).asideContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CMSCard/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: (LeafletLayout_module_default()).asideTitle,
            children: "\u03A6\u03C5\u03BB\u03BB\u03AC\u03B4\u03B9\u03B1"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: (LeafletLayout_module_default()).offersList,
            children: fulladiaLinks.data[0].fields.fulladiaLink.map(function (link) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (LeafletLayout_module_default()).listItemBorder,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: link['fulladiaLink-url'],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (LeafletLayout_module_default()).links,
                    children: "".concat(link['fulladiaLink-title'])
                  })
                })
              }, link['fulladiaLink-url']);
            })
          })]
        }),  true && /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter/* default */.Z, {})]
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/utils/getBreadcrumb.js
var getBreadcrumb = __webpack_require__(65269);
// EXTERNAL MODULE: ./src/pages/fulladia/fulladia.module.scss
var fulladia_module = __webpack_require__(37009);
var fulladia_module_default = /*#__PURE__*/__webpack_require__.n(fulladia_module);
;// CONCATENATED MODULE: ./src/pages/fulladia/[slug].jsx











var __N_SSG = true;
function Leaflet(_ref) {
  var leaflet = _ref.leaflet,
      navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      fulladiaLinks = _ref.fulladiaLinks,
      slug = _ref.slug,
      meta = _ref.meta;

  var _useState = (0,react.useState)(undefined),
      leafletData = _useState[0],
      setLeafletData = _useState[1];

  var breadcrumbData = (0,getBreadcrumb/* getBreadcrumbTwoStep */.xk)(slug);
  var breadcrumb = (0,getBreadcrumb/* createBreadcrumbJson */.El)(breadcrumbData);
  (0,react.useEffect)(function () {
    setLeafletData(leaflet);
  }, [slug]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      meta: meta
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), leaflet && leaflet[0].fields.sections[0].summary !== 'fulladioflip' && /*#__PURE__*/(0,jsx_runtime.jsx)(LeafletLayout, {
      leaflet: leafletData,
      fulladiaLinks: fulladiaLinks,
      slug: slug
    }), leaflet && leaflet[0].fields.sections[0].summary === 'fulladioflip' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
        className: (fulladia_module_default()).iframe,
        src: leaflet[0].fields.sections[0]['leaflet-url'],
        title: "\u03A0\u03BB\u03AE\u03C1\u03B5\u03C2 \u03C6\u03C5\u03BB\u03BB\u03AC\u03B4\u03B9\u03BF"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 65269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ getBreadcrumbValidation; },
/* harmony export */   "El": function() { return /* binding */ createBreadcrumbJson; },
/* harmony export */   "aY": function() { return /* binding */ getBreadcrumbStepProduct; },
/* harmony export */   "xk": function() { return /* binding */ getBreadcrumbTwoStep; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

function createBreadcrumbJson(list) {
  var breadcrumb = list.map(function (value, index) {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: value.name,
      item: value.url
    };
  });
  var json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb
  };
  return json;
}
function getBreadcrumbStepProduct(slug, index) {
  var step = slug.slice(0, index + 1).join('/');

  if (index === slug.length - 1) {
    return {
      url: "".concat("https://kritikos-sm.gr", "/products/").concat(step, "/"),
      name: slug[index].split('-')[0]
    };
  }

  return {
    url: "".concat("https://kritikos-sm.gr", "/categories/").concat(step, "/"),
    name: slug[index]
  };
}
function getBreadcrumbValidation(data) {
  if (data.length === 4) {
    return [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(0, 2)), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(3)));
  }

  return data;
}
function getBreadcrumbTwoStep(link) {
  var firstStep = link.split('/')[0];
  return [{
    url: "".concat("https://kritikos-sm.gr", "/").concat(firstStep, "/"),
    name: firstStep
  }, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(link, "/"),
    name: link.split('/')[1]
  }];
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  createBreadcrumbJson: createBreadcrumbJson,
  getBreadcrumbStepProduct: getBreadcrumbStepProduct,
  getBreadcrumbTwoStep: getBreadcrumbTwoStep,
  getBreadcrumbValidation: getBreadcrumbValidation
});

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 50215:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fulladia/[slug]",
      function () {
        return __webpack_require__(32562);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CMSCard_card__H1j4b"};

/***/ }),

/***/ 12405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"FormattedImage_img__ai6L8"};

/***/ }),

/***/ 61429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GenericModalV2_modalContainer__aCXv8","modalContent":"GenericModalV2_modalContent__Mpl98","text":"GenericModalV2_text__vXm9C","footer":"GenericModalV2_footer__YXTWC","btn":"GenericModalV2_btn__rhKmF"};

/***/ }),

/***/ 20516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leafletContainer":"LeafletLayout_leafletContainer__o0sQT","asideContainer":"LeafletLayout_asideContainer__QbEMt","leaflet":"LeafletLayout_leaflet__o1LUg","linkButtonContainer":"LeafletLayout_linkButtonContainer__SODzu","offersLink":"LeafletLayout_offersLink__NlUml","pdfLink":"LeafletLayout_pdfLink__I_z9g","leafletTitle":"LeafletLayout_leafletTitle__nHrJ6","categoriesAside":"LeafletLayout_categoriesAside__uenvH","textContent":"LeafletLayout_textContent__xkksK","videoContainer":"LeafletLayout_videoContainer__Jwzwv","video":"LeafletLayout_video__uEZMD","img":"LeafletLayout_img__DPTvO","asideTitle":"LeafletLayout_asideTitle___knx3","offersList":"LeafletLayout_offersList__6sZ00","listItemBorder":"LeafletLayout_listItemBorder__3sdAy","links":"LeafletLayout_links__R2a_L","buttonContainer":"LeafletLayout_buttonContainer__m_m5R","newsletterInput":"LeafletLayout_newsletterInput__FCNQD","newsletterButton":"LeafletLayout_newsletterButton__K9BO6","offerContainer":"LeafletLayout_offerContainer__ZnozA"};

/***/ }),

/***/ 15342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"LeafletSlide_img__JUqX_","container":"LeafletSlide_container__4_DD5"};

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ }),

/***/ 97844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Newsletter_title__I8Mqt","group":"Newsletter_group__JpG9b","input":"Newsletter_input__3socT","button":"Newsletter_button__atuwY"};

/***/ }),

/***/ 80075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NextArrow_container__QNOMg","leaflet":"NextArrow_leaflet__pv9Bi","categoryContainer":"NextArrow_categoryContainer__32KPf","smallArrow":"NextArrow_smallArrow__eYUrr","carouselContainer":"NextArrow_carouselContainer__PSlWF","icon":"NextArrow_icon__cN9Ar"};

/***/ }),

/***/ 19392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PrevArrow_container__ebi1s","leaflet":"PrevArrow_leaflet__sW3Rf","smallArrow":"PrevArrow_smallArrow__BjbkX","categoryContainer":"PrevArrow_categoryContainer__iWgpN","carouselContainer":"PrevArrow_carouselContainer__4XFzB","icon":"PrevArrow_icon__Wjv_m"};

/***/ }),

/***/ 37009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iframe":"fulladia_iframe__yUyvF"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 91:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,3253,3996,4843,1515,9950,9067,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(50215); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);